import { render, staticRenderFns } from "./Sicbo.vue?vue&type=template&id=da353cac&scoped=true"
import script from "./Sicbo.vue?vue&type=script&lang=js"
export * from "./Sicbo.vue?vue&type=script&lang=js"
import style0 from "./Sicbo.vue?vue&type=style&index=0&id=da353cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da353cac",
  null
  
)

export default component.exports